import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'category-icon',
  templateUrl: './category-icon.component.html',
  styleUrls: ['./category-icon.component.scss']
})
export class CategoryIconComponent implements OnInit {

  @Input() icon: string;
  @Input() title: string;
  @Input() category: string;
  @Input() showLabel: boolean = false;

  constructor() { }

  ngOnInit() {
  }

  get iconName(){
    let icon = '';
    switch(this.category){
      case 'group':
        icon = 'collections_bookmark' || 'list' || 'group_work';
        break;
      case 'park':
        icon = 'nature_people';
        break;
      case 'vine':
        icon = 'local_bar';
        break;
      case 'food':
        icon = 'local_dining';
        break;
      case 'relax':
        icon = 'beach_access';
        break;
      case 'historical':
        icon = 'account_balance';
        break;
      case 'religion':
        icon = 'notifications';
        break;
      case 'view':
        icon = 'terrain' || 'local_see';
        break;
      case 'zoo':
        icon = 'pets';
        break;


      case 'choose':
        icon = 'touch_app';
        break;
      case 'discover':
        icon = 'explore';
        break;
      case 'join':
        icon = 'event';
        break;
      case 'favourites':
      case 'favorite':
        icon = 'favorite';
        break;

      case 'generate':
        icon = 'autorenew';
        break;


      case 'random':
        icon = 'bubble_chart';
        break;
      case 'in-country':
      case 'inCcountry':
        icon = 'track_changes';
        this.title = 'In Country';
        break;
      case 'in-circle':
      case 'inCircle':
        icon = 'filter_tilt_shift';
        this.title = 'In Circle';
        break;

      case 'is-poi':
        icon = 'bubble_chart';
        break;
      case 'is-trip':
        icon = 'timeline';
        break;
    }
    return icon;
  }

}



// WEBPACK FOOTER //
// C:/Development/Private Projects/random-ride/RandomRide/src/app/category-icon/category-icon.component.ts